import React, {Component, ReactElement, ReactNode} from 'react'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    ADMINISTORATOR_MODE,
    LIFE_CONVENIENT_BOOK_CATEGORY,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    SELECT_CONDOMINIUM_TYPE,
    TARGET_ATT,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import NatDeliveryTargetAreaSelectionComponent from '../common/admin/NatDeliveryTargetAreaSelectionComponent'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {getYearAfterNextDate, getYearDate} from '../../common/util/Natutil'
import PPImageInputWithPreview, {ImageInformation} from '../../../components/shared/forms/PPImageInputWithPreview'
import {LifeNoteNotDeliveryCondominiumList, NatPostLifeNote, NatPostLifeNoteParams} from './repository/NatPostLifeNote'
import NatLifeNoteRepo from './repository/NatLifeNoteRepo'
import {formatForDateInput} from '../../../formatters/formatDate'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import styled from 'styled-components'
import {StyledDiv, StyledLabel, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import PPInput from '../../../components/shared/forms/PPInput'
import {FontWeights} from '../../../styledComponents/Constants'
import PPErrorLabel from '../../../components/shared/forms/PPErrorLabel'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

interface LocationState {
    registrationDate: string
}

interface Props {
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    lifeNoteRepo: NatLifeNoteRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>
}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    selectedCondominiumGroupId: number | null
    selectedExcludeCondominiumInfo: CondominiumInfo[]
    deliveryTargetPrefectureCd: string
    deliveryTargetAddress2: string
    selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]
    dialogOpenSelectExcludeCondominium: boolean
    dialogOpenSelectDeliveryTargetArea: boolean
    category: string
    title: string
    description: string
    publishStartDate: string
    publishEndDate: string
    publishStartDateMin: string
    publishStartDateMax: string
    publishEndDateMin: string
    publishEndDateMax: string
    sortOrder: string
    targetAttr: string
    url: string
    selectedImagesInfo: ImageInformation[]
    isLoadCompleted: boolean
    selectedMaxDateTime: string

}

class NatAdminLifeNoteRegisterPage extends Component<Props & AdminPagePropsSet, States> {
    administratorMode: Nullable<string>
    loginUserCondominiumGroupId: Nullable<number>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        this.administratorMode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)
        this.loginUserCondominiumGroupId =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        this.state = {
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            selectedCondominiumGroupId: this.loginUserCondominiumGroupId,
            selectedExcludeCondominiumInfo: [],
            selectedDeliveryTargetCondominiumInfo: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            dialogOpenSelectExcludeCondominium: false,
            dialogOpenSelectDeliveryTargetArea: false,
            category: '',
            title: '',
            description: '',
            publishStartDate: '',
            publishEndDate: '',
            publishStartDateMin: '',
            publishStartDateMax: '',
            publishEndDateMin: '',
            publishEndDateMax: '',
            sortOrder: '',
            targetAttr: TARGET_ATT.NEW.value,
            url: '',
            selectedImagesInfo: [],
            isLoadCompleted: false,
            selectedMaxDateTime: '',
        }

        this.handleOpenExclusionCondominiumSelectionDialog =
            this.handleOpenExclusionCondominiumSelectionDialog.bind(this)
        this.handleCloseSelectCondominiumDiaLog = this.handleCloseSelectCondominiumDiaLog.bind(this)
        this.handleOpenDeliveryTargetAreaSelectionDialog = this.handleOpenDeliveryTargetAreaSelectionDialog.bind(this)
        this.handleCloseDeliveryTargetAreaSelectionDialog =
            this.handleCloseDeliveryTargetAreaSelectionDialog.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.onChangeCategory = this.onChangeCategory.bind(this)
        this.onChangeTitle = this.onChangeTitle.bind(this)
        this.onChangePublishStartDate = this.onChangePublishStartDate.bind(this)
        this.onChangePublishEndDate = this.onChangePublishEndDate.bind(this)
        this.onChangeSortOrder = this.onChangeSortOrder.bind(this)
        this.onChangeUrl = this.onChangeUrl.bind(this)
        this.onChangeTargetAttr = this.onChangeTargetAttr.bind(this)
        this.onChangeImages = this.onChangeImages.bind(this)
        this.onChangeDescription = this.onChangeDescription.bind(this)
        this.getTargetAttRadioGroupData = this.getTargetAttRadioGroupData.bind(this)
        this.setSelectedExclusionCondominiumInfo = this.setSelectedExclusionCondominiumInfo.bind(this)
        this.setSelectedDeliveryTargetCondominiumInfo = this.setSelectedDeliveryTargetCondominiumInfo.bind(this)
        this.setDeliveryTargetPrefectureCd = this.setDeliveryTargetPrefectureCd.bind(this)
        this.setDeliveryTargetAddress2 = this.setDeliveryTargetAddress2.bind(this)
        this.registerLifeNoteButton = this.registerLifeNoteButton.bind(this)
        this.judgregisterLifeNoteButton = this.judgregisterLifeNoteButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 全体モード時のみ物件グループを取得
            if (this.administratorMode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }
            }
            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                const yearAfterNext: string = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.setState({
                    selectedMaxDateTime: yearAfterNext,
                    publishStartDateMin: getYearDate(),
                    publishStartDateMax: yearAfterNext,
                    publishEndDateMin: getYearDate(),
                    publishEndDateMax: yearAfterNext,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }


    handleOpenExclusionCondominiumSelectionDialog(): void {
        this.setState({
            dialogOpenSelectExcludeCondominium: true,
        })
    }

    handleCloseSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectExcludeCondominium: false})
    }

    handleOpenDeliveryTargetAreaSelectionDialog(): void {
        this.setState({
            dialogOpenSelectDeliveryTargetArea: true,
        })
    }

    handleCloseDeliveryTargetAreaSelectionDialog(): void {
        this.setState({dialogOpenSelectDeliveryTargetArea: false})
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        let lifeNoteFileName: string | null = null
        let lifeNoteFileData: string | null = null

        if (this.state.selectedImagesInfo.length > 0) {
            this.state.selectedImagesInfo.some((selectedImage) => {
                lifeNoteFileName = selectedImage.name as string
                lifeNoteFileData = selectedImage.base64data as string
                return true
            })
        }

        const lifeNoteNotDeliveryCondominiumList: LifeNoteNotDeliveryCondominiumList[] = []
        if (this.state.selectedExcludeCondominiumInfo.length > 0) {
            this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
                lifeNoteNotDeliveryCondominiumList.push(
                    {condominiumCd: condominiumInfo.condominiumCd},
                )
            })
        }

        const request: NatPostLifeNoteParams = {
            lifeNoteNotDeliveryCondominium: lifeNoteNotDeliveryCondominiumList,
            deliveryTargetPrefectureCd:
                this.state.deliveryTargetPrefectureCd === '' ? null : this.state.deliveryTargetPrefectureCd,
            deliveryTargetAddress2:
                this.state.deliveryTargetAddress2 === '' ? null : this.state.deliveryTargetAddress2,
            categoryId: this.state.category,
            title: this.state.title,
            description: this.state.description,
            publishStartDate: this.state.publishStartDate ? formatForDateInput(this.state.publishStartDate) : '',
            publishEndDate: this.state.publishEndDate ? formatForDateInput(this.state.publishEndDate) : '',
            sortOrder: this.state.sortOrder,
            url: this.state.url,
            targetAttr: this.state.targetAttr,
            lifeNoteFileName: lifeNoteFileName,
            lifeNoteFileData: lifeNoteFileData,
        }
        if (this.state.selectedCondominiumGroupId) {
            request.condominiumGroupId = this.state.selectedCondominiumGroupId
        }

        try {
            const registerLifeNoteResponse: Nullable<NatPostLifeNote> = await this.props.asyncCallFunction(
                this.props.lifeNoteRepo.postLifeNote.bind(this.props.lifeNoteRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0001.toString('生活便利帳')},
            )
            if (registerLifeNoteResponse &&
                registerLifeNoteResponse.details &&
                registerLifeNoteResponse.requestError === null) {
                this.props.navigate(`/admin/lifeNote/` + registerLifeNoteResponse.details.lifeNoteId,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0004.toString('生活便利帳', this.state.title),
                            },
                        },
                    },
                )
            } else {
                return
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        this.setState({
            selectedCondominiumGroupId: condomoniumGroupId,
            selectedExcludeCondominiumInfo: [],
        })
    }

    onChangeCategory(event: SelectChangeEvent<unknown>): void {
        this.setState({category: event.target.value as string})
    }

    onChangeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({title: event.target.value})
    }

    onChangeDescription(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        this.setState({description: event.target.value as string})
    }

    onChangePublishStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({publishStartDate: date.toString(), publishEndDateMin: date.toString()})
        } else {
            this.setState({publishStartDate: '', publishEndDateMin: getYearDate()})
        }
    }

    onChangePublishEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({publishEndDate: date.toString(), publishStartDateMax: date.toString()})
        } else {
            this.setState({publishEndDate: '', publishStartDateMax: this.state.selectedMaxDateTime})
        }
    }

    onChangeSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({sortOrder: event.target.value})
    }

    onChangeUrl(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({url: event.target.value})
    }

    onChangeTargetAttr(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({targetAttr: event.target.value})
    }

    onChangeImages(images: ImageInformation[]): void {
        this.setState({selectedImagesInfo: images})
    }

    // カテゴリー
    getCategoryList(): OptionProps[] {
        let categories: OptionProps[]

        categories = LIFE_CONVENIENT_BOOK_CATEGORY.values().map((category) => {
            return ({
                label: `${category.label}`,
                value: `${category.value}`,
            })
        })

        return [{
            label: 'カテゴリを選択してください',
            value: '',
        }, ...categories]
    }

    // ターゲット属性
    getTargetAttRadioGroupData(): PPRadioItemProp[] {
        const targetAttRadioGroupData: PPRadioItemProp[] = []
        TARGET_ATT.values().map((targetAttr) => (
            targetAttRadioGroupData.push(
                {
                    label: targetAttr.label,
                    value: targetAttr.value,
                    radioProps: {
                        checked: targetAttr.value === this.state.targetAttr,
                        onChange: this.onChangeTargetAttr,
                    },
                },
            )
        ))
        return targetAttRadioGroupData
    }

    setSelectedExclusionCondominiumInfo(selectedExcludeCondominiumInfo: CondominiumInfo[]): void {
        selectedExcludeCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            dialogOpenSelectExcludeCondominium: false,
        })
    }

    setSelectedDeliveryTargetCondominiumInfo(selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]): void {
        selectedDeliveryTargetCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedDeliveryTargetCondominiumInfo: selectedDeliveryTargetCondominiumInfo,
            dialogOpenSelectDeliveryTargetArea: false,
        })
    }

    setDeliveryTargetPrefectureCd(deliveryTargetPrefectureCd: string): void {
        this.setState({
            deliveryTargetPrefectureCd: deliveryTargetPrefectureCd,
        })
    }

    setDeliveryTargetAddress2(deliveryTargetAddress2: string): void {
        this.setState({
            deliveryTargetAddress2: deliveryTargetAddress2,
        })
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    async registerLifeNoteButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('生活便利帳'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    judgregisterLifeNoteButton(): boolean {
        const disabled: boolean = true

        // 全体モード
        if (this.administratorMode === ADMINISTORATOR_MODE.ALL.value &&
            this.state.condominiumGroup === null) {
            return true
        }

        if (this.state.category !== '' &&
            this.state.title !== '' &&
            this.state.publishStartDate !== '' &&
            this.state.url !== '' &&
            this.state.targetAttr !== '') {
            return false
        }

        return disabled
    }

    deleteExcludeCondominium(condominiumCd: string): void {
        const selectedExcludeCondominiumInfo: CondominiumInfo[] = []
        this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
            if (condominiumInfo.condominiumCd !== condominiumCd) {
                selectedExcludeCondominiumInfo.push(condominiumInfo)
            }
        })
        this.setState({selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo})
    }

    deleteDeliveryTargetArea(): void {
        this.setState({deliveryTargetPrefectureCd: ''})
    }

    renderDeliveryTargetArea(): ReactNode {

        return (
            <>
                <TableRow>
                    <TableRowName>
                        配信対象を地域から選択
                    </TableRowName>
                    <TableCell colSpan={3}>
                        <LeftRowFlexContainer>
                            <AdminDefaultMediumButton
                                onClick={this.handleOpenDeliveryTargetAreaSelectionDialog}
                                size={'small'}
                            >
                                地域を選択
                            </AdminDefaultMediumButton>
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeliveryTargetArea>
                                    <DeliveryTargetAreaTxt>
                                        {` 指定地域: `
                                            + this.getPrefectureName(this.state.deliveryTargetPrefectureCd)
                                            + this.state.deliveryTargetAddress2
                                        }
                                    </DeliveryTargetAreaTxt>
                                </DeliveryTargetArea>
                                : ``
                            }
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeleteLink onClick={(event: React.MouseEvent) => {
                                    event.preventDefault()
                                    this.setState({
                                        deliveryTargetPrefectureCd: '',
                                        deliveryTargetAddress2: '',
                                        selectedDeliveryTargetCondominiumInfo: [],
                                    })
                                }}>
                                    削除
                                </DeleteLink>
                                : ''
                            }
                        </LeftRowFlexContainer>
                        {this.state.dialogOpenSelectDeliveryTargetArea && this.state.condominiumGroup.details &&
                            <NatDeliveryTargetAreaSelectionComponent
                                condominiumRepo={this.props.condominiumRepo}
                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                closeSelectDeliveryTargetAreaDiaLog=
                                    {this.handleCloseDeliveryTargetAreaSelectionDialog}
                                setSelectedDeliveryTargetCondominiumInfo=
                                    {this.setSelectedDeliveryTargetCondominiumInfo}
                                setDeliveryTargetPrefectureCd={this.setDeliveryTargetPrefectureCd}
                                setDeliveryTargetAddress2={this.setDeliveryTargetAddress2}
                                eventEmitter={this.props.eventEmitter}
                                selectedCondominiumGroupId={this.state.selectedCondominiumGroupId}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {
                            <InnerMiniTable>
                                <InnerMiniTableBody>
                                    {
                                        this.state.selectedDeliveryTargetCondominiumInfo.map(
                                            (condominiumInfo, index) => {
                                                return (
                                                    <TableRow key={condominiumInfo.condominiumCd}>
                                                        <InnerMiniTableCell>
                                                            {condominiumInfo.condominiumCd + ' ' +
                                                                condominiumInfo.condominiumName}
                                                            <PPErrorLabel
                                                                eventEmitter={this.props.eventEmitter}
                                                                eventKeys={[`lifeNoteDeliveryTargetCondominium[${index}].condominiumCd`]}
                                                            />
                                                        </InnerMiniTableCell>
                                                    </TableRow>
                                                )
                                            })
                                    }
                                </InnerMiniTableBody>
                            </InnerMiniTable>
                        }
                    </TableCell>
                </TableRow>
            </>
        )
    }

    renderEventFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>生活便利帳情報</StyledTableCaption>
                    <TableBody>
                        {(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                            <>
                                <TableRow>
                                    <TableRowName required>物件グループを選択</TableRowName>

                                    {
                                        this.state.condominiumGroup &&
                                        this.state.condominiumGroup.details &&
                                        <>
                                            <TableCell colSpan={3}>
                                                <NatCondominiumGroupSelectComponent
                                                    condominiumGroup={this.state.condominiumGroup.details}
                                                    defaultValue={this.state.selectedCondominiumGroupId}
                                                    onChangeSelectedCondominiumGroupId=
                                                        {this.onChangeSelectedCondominiumGroupId}
                                                    requiredFlag={true}
                                                    eventKeys={['condominiumGroupId']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    autoFocus={true}
                                                >
                                                </NatCondominiumGroupSelectComponent>
                                            </TableCell>
                                        </>
                                    }
                                </TableRow>
                                {this.renderDeliveryTargetArea()}
                                <TableRow>
                                    <TableRowName rowSpan={this.state.selectedExcludeCondominiumInfo.length + 1}>
                                        除外する物件を選択
                                    </TableRowName>
                                    <TableCell colSpan={3}>
                                        <AdminDefaultMediumButton
                                            onClick={this.handleOpenExclusionCondominiumSelectionDialog}
                                            size={'small'}
                                        >
                                            物件を選択
                                        </AdminDefaultMediumButton>
                                    </TableCell>
                                </TableRow>
                                {this.state.dialogOpenSelectExcludeCondominium && this.state.condominiumGroup.details &&
                                    <NatCondominiumSelectionComponent
                                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                                        condominiumRepo={this.props.condominiumRepo}
                                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                                        closeSelectCondominiumDiaLog={this.handleCloseSelectCondominiumDiaLog}
                                        setSelectedExclusionCondominiumInfo={this.setSelectedExclusionCondominiumInfo}
                                        eventEmitter={this.props.eventEmitter}
                                        selectedCondominiumGroupId={this.state.selectedCondominiumGroupId}
                                        navigate={this.props.navigate}
                                        location={this.props.location}
                                        asyncCallFunction={this.props.asyncCallFunction}
                                        excludeCondominium={this.state.selectedExcludeCondominiumInfo}
                                    />
                                }
                                {this.state.selectedExcludeCondominiumInfo.length > 0 &&
                                    this.state.selectedExcludeCondominiumInfo.map((condominiumInfo, index) => {
                                        return (
                                            <TableRow>
                                                <TableCell colSpan={3}>
                                                    <LeftRowFlexContainer>
                                                        <SelectedNotDeliveryCondominium>
                                                            <PPInput
                                                                type="label"
                                                                value={condominiumInfo.condominiumCd +
                                                                    ' ' + condominiumInfo.condominiumName}
                                                                eventKeys={
                                                                    [`lifeNoteNotDeliveryCondominium[${index}].condominiumCd`]
                                                                }
                                                                eventEmitter={this.props.eventEmitter}
                                                            />
                                                        </SelectedNotDeliveryCondominium>
                                                        <SelectedNotDeliveryCondominium>
                                                            <DeleteLink onClick={(event: React.MouseEvent) => {
                                                                event.preventDefault()
                                                                this.deleteExcludeCondominium(
                                                                    condominiumInfo.condominiumCd,
                                                                )
                                                            }}>
                                                                削除
                                                            </DeleteLink>
                                                        </SelectedNotDeliveryCondominium>
                                                    </LeftRowFlexContainer>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </> : null
                        }
                        <TableRow>
                            <TableRowName required>カテゴリ</TableRowName>
                            <TableCell colSpan={3}>
                                <PPSelect
                                    data={this.getCategoryList()}
                                    onChange={this.onChangeCategory}
                                    eventKeys={['categoryId']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.category}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.title}
                                    onChange={this.onChangeTitle}
                                    eventKeys={['title']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>メモ</TableRowName>
                            <TableCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 100,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    multiline
                                    value={this.state.description}
                                    onChange={this.onChangeDescription}
                                    eventKeys={['description']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>掲載開始日</TableRowName>
                            <TableCell colSpan={3}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangePublishStartDate}
                                                value={(this.state.publishStartDate) ?
                                                    new Date(this.state.publishStartDate) : null
                                                }
                                                minDate={(this.state.publishStartDateMin) ?
                                                    new Date(this.state.publishStartDateMin) : null
                                                }
                                                maxDate={(this.state.publishStartDateMax) ?
                                                    new Date(this.state.publishStartDateMax) : null
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishStartDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載終了日</TableRowName>
                            <TableCell colSpan={3}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.onChangePublishEndDate}
                                                value={(this.state.publishEndDate) ?
                                                    new Date(this.state.publishEndDate) : null
                                                }
                                                minDate={(this.state.publishEndDateMin) ?
                                                    new Date(this.state.publishEndDateMin) : null
                                                }
                                                maxDate={(this.state.publishEndDateMax) ?
                                                    new Date(this.state.publishEndDateMax) : null
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishEndDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>並び順</TableRowName>
                            <TableCell colSpan={3}>
                                <PPNumericField
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                            max: 999,
                                        },
                                    }}
                                    placeholder={'999'}
                                    onChange={this.onChangeSortOrder}
                                    value={this.state.sortOrder}
                                    eventKeys={['sortOrder']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>リンク先URL</TableRowName>
                            <TableCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 256,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.url}
                                    onChange={this.onChangeUrl}
                                    eventKeys={['url']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>ターゲット属性</TableRowName>
                            <TableCell colSpan={3}>
                                <PPRadioGroup
                                    row
                                    data={this.getTargetAttRadioGroupData()}
                                    eventKeys={['targetAttr']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>画像</TableRowName>
                            <TableCell colSpan={3}>
                                <PPImageInputWithPreview
                                    images={this.state.selectedImagesInfo}
                                    maxCount={1}
                                    maxFileSizeBytesPerFile={5 * 1024 * 1024}
                                    maxFileSizeBytesPerFileMessage={
                                        'アップロードファイルの上限サイズは1ファイルあたり5MBまでです'
                                    }
                                    helperText={<div>5MBまで</div>}
                                    onChange={this.onChangeImages}
                                    eventKeys={['lifeNoteFileData']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgregisterLifeNoteButton()}
                        onClick={this.registerLifeNoteButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            '/admin/lifeNoteList',
                        )}
                    >
                        生活便利帳検索へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderEventFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

const DeliveryTargetAreaTxt: StyledSpan = styled.span`
  font-weight: ${FontWeights.Bold};
`
const DeliveryTargetArea: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const SelectedNotDeliveryCondominium: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const SelectedDeliveryTargetCondominium: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`

export default createAdminPage(NatAdminLifeNoteRegisterPage)
